"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2811],{

/***/ 84899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75833);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prismic_reactjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ArticleMeta__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84679);
/* harmony import */ var _models_enums_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20365);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86555);





const ArticleHeader = (props)=>{
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        className: "".concat(props.className, "-header"),
        children: [
            props.titleIsLink ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .ArticleHeaderLink */ .c3, {
                href: "".concat(_models_enums_routes__WEBPACK_IMPORTED_MODULE_2__/* .Routes.InsightsArticleId */ .Z.InsightsArticleId).concat(prismic_reactjs__WEBPACK_IMPORTED_MODULE_0__.RichText.asText(props.seo_url)),
                children: prismic_reactjs__WEBPACK_IMPORTED_MODULE_0__.RichText.asText(props.title)
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .ArticleHeaderLinkH1 */ .H$, {
                className: "article-header__title",
                children: prismic_reactjs__WEBPACK_IMPORTED_MODULE_0__.RichText.asText(props.title)
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_ArticleMeta__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                className: props.className,
                author: props.author,
                publishDate: props.publishDate,
                tags: props.tags,
                authorImage: props.authorImage
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleHeader);


/***/ }),

/***/ 69673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _models_enums_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20365);
/* harmony import */ var _utils_imageSerializer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9790);





const ArticleImage = (props)=>{
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
        className: "".concat(props.className, "__image"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: "".concat(_models_enums_routes__WEBPACK_IMPORTED_MODULE_2__/* .Routes.InsightsArticleId */ .Z.InsightsArticleId).concat(props.url),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
                ...(0,_utils_imageSerializer__WEBPACK_IMPORTED_MODULE_4__/* .imageSerializer */ .l)(props.image)
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleImage);


/***/ }),

/***/ 84679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75833);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prismic_reactjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _models_enums_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20365);
/* harmony import */ var _utils_imageSerializer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9790);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86555);






const ArticleMeta = (props)=>{
    const formattedPublishDate = new Date(props.publishDate).toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
        year: "numeric"
    });
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        className: "".concat(props.className, "-meta"),
        children: [
            props.authorImage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                className: "".concat(props.className, "-meta__image"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    ...(0,_utils_imageSerializer__WEBPACK_IMPORTED_MODULE_5__/* .imageSerializer */ .l)(props.authorImage),
                    className: "person__image"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
                className: "".concat(props.className, "-meta__info"),
                children: [
                    props.author && prismic_reactjs__WEBPACK_IMPORTED_MODULE_0__.RichText.asText(props.author) !== "" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .MetaName */ .hv, {
                        children: prismic_reactjs__WEBPACK_IMPORTED_MODULE_0__.RichText.asText(props.author)
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
                        className: "".concat(props.className, "-meta__details"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .MetaDate */ .yY, {
                                children: formattedPublishDate
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                                className: "divider",
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
                                children: props.tags.map((tag)=>/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .MetaTagLink */ .GJ, {
                                        href: "".concat(_models_enums_routes__WEBPACK_IMPORTED_MODULE_2__/* .Routes.InsightsTag */ .Z.InsightsTag).concat(tag),
                                        "aria-label": tag,
                                        className: "".concat(props.className, "-meta__tag"),
                                        children: tag
                                    }, tag))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleMeta);


/***/ }),

/***/ 92811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Articles; },
  "y": function() { return /* binding */ numberOfItemsOnPage; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./components/sections/Articles/ArticleHeader.tsx
var ArticleHeader = __webpack_require__(84899);
// EXTERNAL MODULE: ./components/sections/Articles/ArticleLinkImage.tsx
var ArticleLinkImage = __webpack_require__(69673);
// EXTERNAL MODULE: ./models/enums/routes.ts
var routes = __webpack_require__(20365);
// EXTERNAL MODULE: ./components/sections/Articles/styles.tsx
var styles = __webpack_require__(86555);
;// CONCATENATED MODULE: ./components/sections/Articles/ArticleSummary.tsx







const ArticleSummary = (param)=>{
    let { article , contentPage  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* ArticleSummaryWrapper */.Q4, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleHeader/* default */.Z, {
                title: article.title,
                className: "article-summary",
                seo_url: article.seo_url,
                author: article.author,
                publishDate: article._meta.firstPublicationDate,
                tags: article._meta.tags,
                authorImage: article.author_image,
                titleIsLink: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleLinkImage/* default */.Z, {
                className: "article-summary",
                image: article.article_image,
                url: prismic_reactjs.RichText.asText(article.seo_url),
                title: prismic_reactjs.RichText.asText(article.title)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* ArticleSummaryContent */._6, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        children: article.content[0].text
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ArticleSummaryReadMore */.M3, {
                        href: "".concat(routes/* Routes.InsightsArticleId */.Z.InsightsArticleId).concat(prismic_reactjs.RichText.asText(article.seo_url)),
                        children: prismic_reactjs.RichText.asText(contentPage.read_more_button || "")
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(21977);
;// CONCATENATED MODULE: ./utils/getArrayForRange.ts
const getArrayForRange = (startIndex, endIndex)=>{
    const numberOfItems = endIndex - startIndex + 1;
    return Array.from({
        length: numberOfItems
    }, (_, id)=>id + startIndex);
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
;// CONCATENATED MODULE: ./components/core/Pagination/pagination.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 7.5rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-color: ",
        ";\n\n      &:hover {\n        box-shadow: none;\n      }\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      stroke: ",
        ";\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}




const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", {
    target: "eguvppw0"
})("display:flex;margin-top:2.5rem;margin-bottom:5rem;padding:0;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";");
const Page = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", {
    target: "eguvppw1"
})("display:flex;width:3rem;height:3rem;border:0.0625rem solid #d8dfe4;border-radius:3.75rem;align-items:center;justify-content:center;box-sizing:border-box;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-weight:normal;font-size:1.25rem;line-height:1.875rem;margin-right:1rem;cursor:pointer;transition:box-shadow 200ms ease-in-out;&:hover{box-shadow:0.5rem 0.5rem 1.5rem 0 #1700594a;}", (param)=>{
    let { isActive  } = param;
    return isActive && (0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), theme/* THEME.colors.primary */.C.colors.primary);
}, ";");
const Dots = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", {
    target: "eguvppw2"
})("margin-right:1rem;display:flex;justify-content:center;align-items:center;");
const PaginationArrow = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", {
    target: "eguvppw3"
})("width:3rem;height:3rem;border:0.0625rem solid #d8dfe4;box-sizing:border-box;border-radius:3.75rem;display:flex;align-items:center;justify-content:center;cursor:pointer;");
const ArrowPath = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("path", {
    target: "eguvppw4"
})((param)=>{
    let { isActive  } = param;
    return isActive && (0,emotion_react_browser_esm/* css */.iv)(_templateObject2(), theme/* THEME.colors.black */.C.colors.black);
}, ";");
const PaginationArrowBack = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaginationArrow, {
    target: "eguvppw5"
})("margin-right:1rem;");

;// CONCATENATED MODULE: ./components/core/Pagination/pagination.hooks.tsx





const DOTS_COMPONENT = "dots_component";
const usePagination = (param)=>{
    let { pageSize , totalCount , activePage , onPageChange , relatedParams  } = param;
    const paginationRef = (0,react.useRef)(null);
    const pagesLength = (0,react.useMemo)(()=>Math.ceil(totalCount / pageSize), [
        pageSize,
        totalCount
    ]);
    const [numberOfVisiblePages, setNumberOfVisiblePages] = (0,react.useState)(0);
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const timeoutRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            var _ref, _ref1;
            const parentWidth = windowSize.width && windowSize.width > 500 ? (_ref = paginationRef === null || paginationRef === void 0 ? void 0 : paginationRef.current) === null || _ref === void 0 ? void 0 : _ref.parentElement.clientWidth : window.innerWidth;
            const childWidth = (_ref1 = paginationRef === null || paginationRef === void 0 ? void 0 : paginationRef.current) === null || _ref1 === void 0 ? void 0 : _ref1.children[0].clientWidth;
            const _numberOfVisiblePages = Math.floor(parentWidth / (childWidth + 20)) - 2;
            setNumberOfVisiblePages(_numberOfVisiblePages);
        }, 500);
    }, [
        windowSize
    ]);
    const clickNextPageHandler = ()=>{
        if (activePage >= pagesLength) {
            return;
        }
        const currentPage = activePage + 1;
        onPageChange(currentPage);
    };
    const clickBackPageHandler = ()=>{
        if (activePage <= 1) {
            return;
        }
        const currentPage = activePage - 1;
        onPageChange(currentPage);
    };
    const paginationPagesRange = (0,react.useMemo)(()=>{
        const isSmall = numberOfVisiblePages <= 3;
        const numberOfElementsIfOneDots = 5;
        const numberOfElementsIfOneDotsSmall = 2;
        const indexOfFirstPage = 1;
        if (numberOfVisiblePages >= pagesLength) {
            return getArrayForRange(1, pagesLength);
        }
        const leftSideElementIndex = Math.max(activePage - 1, indexOfFirstPage);
        const rightSideElementIndex = Math.min(activePage + 1, pagesLength);
        const leftDotsVisible = !isSmall && leftSideElementIndex > 2 || isSmall && activePage >= pagesLength - 1;
        const rightDotsVisible = !isSmall && rightSideElementIndex < pagesLength - 2 || isSmall && activePage < pagesLength - 1;
        if (!leftDotsVisible && rightDotsVisible) {
            const indexLastItemRange = !isSmall ? numberOfElementsIfOneDots : activePage % numberOfElementsIfOneDotsSmall !== 0 ? activePage + 1 : activePage;
            const arrayToShow = getArrayForRange(isSmall ? activePage % numberOfElementsIfOneDotsSmall !== 0 ? activePage : activePage - 1 : 1, indexLastItemRange);
            return [
                ...arrayToShow,
                DOTS_COMPONENT,
                pagesLength
            ];
        }
        if (leftDotsVisible && !rightDotsVisible) {
            const indexFirstItemRange = !isSmall ? numberOfElementsIfOneDots : numberOfElementsIfOneDotsSmall;
            const arrayToShow1 = getArrayForRange(pagesLength - indexFirstItemRange + 1, pagesLength);
            return [
                (!isSmall || numberOfVisiblePages <= 3 && activePage >= pagesLength - 1) && indexOfFirstPage,
                DOTS_COMPONENT,
                ...arrayToShow1
            ];
        }
        if (leftDotsVisible && rightDotsVisible) {
            const arrayToShow2 = getArrayForRange(leftSideElementIndex, rightSideElementIndex);
            return [
                indexOfFirstPage,
                DOTS_COMPONENT,
                ...arrayToShow2,
                DOTS_COMPONENT,
                pagesLength
            ];
        }
    }, [
        activePage,
        numberOfVisiblePages,
        relatedParams
    ]);
    const pages = (0,react.useMemo)(()=>paginationPagesRange.map((pageNumber, index)=>{
            if (pageNumber === DOTS_COMPONENT) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dots, {
                    children: "..."
                }, index + "_dots");
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Page, {
                onClick: ()=>{
                    onPageChange(pageNumber);
                },
                isActive: pageNumber == activePage,
                children: pageNumber
            }, pageNumber);
        }), [
        paginationPagesRange
    ]);
    return {
        paginationRef,
        clickBackPageHandler,
        pages,
        clickNextPageHandler,
        pagesLength
    };
};

;// CONCATENATED MODULE: ./components/core/Pagination/Pagination.tsx




const Pagination = (param)=>{
    let { pageSize , totalCount , onPageChange , activePage , relatedParams  } = param;
    const { paginationRef , clickBackPageHandler , pages , clickNextPageHandler , pagesLength  } = usePagination({
        pageSize,
        totalCount,
        onPageChange,
        activePage,
        relatedParams
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        ref: paginationRef,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaginationArrowBack, {
                onClick: clickBackPageHandler,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                    width: "22",
                    height: "12",
                    viewBox: "0 0 22 12",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowPath, {
                        isActive: activePage > 1,
                        d: "M20.25 6H1.75M1.75 6L6.75 1M1.75 6L6.75 11",
                        stroke: "#D8DFE4",
                        strokeWidth: "2",
                        strokeLinecap: "round"
                    })
                })
            }),
            pages,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaginationArrow, {
                onClick: clickNextPageHandler,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                    width: "22",
                    height: "12",
                    viewBox: "0 0 22 12",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowPath, {
                        isActive: activePage < pagesLength,
                        d: "M1.75 6L20.25 6M20.25 6L15.25 11M20.25 6L15.25 1",
                        stroke: "#D8DFE4",
                        strokeWidth: "2",
                        strokeLinecap: "round"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Pagination_Pagination = (Pagination);

;// CONCATENATED MODULE: ./components/sections/Articles/Articles.tsx






const numberOfItemsOnPage = 10;
const Articles = (param)=>{
    let { articles , articlesCount , currentPage , contentPage  } = param;
    const { query: { tag , number  } , ...router } = (0,next_router.useRouter)();
    const onPageChangeHandler = (pageIndex)=>{
        const routerQuery = {
            page: pageIndex
        };
        if (tag) {
            routerQuery.tag = tag;
        }
        const tagPath = tag ? "tag/".concat(tag, "/") : "";
        const pagePath = pageIndex ? "page/".concat(pageIndex, "/") : "";
        router.push({
            pathname: pageIndex !== 1 ? "/insights/".concat(tagPath).concat(pagePath) : "/insights/".concat(tagPath)
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* ArticlesListSection */.bO, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: articles.map((article, index)=>{
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleSummary, {
                        article: article,
                        contentPage: contentPage
                    }, index);
                })
            }),
            articlesCount > numberOfItemsOnPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pagination_Pagination, {
                totalCount: articlesCount,
                pageSize: numberOfItemsOnPage,
                activePage: currentPage,
                relatedParams: tag,
                onPageChange: onPageChangeHandler
            })
        ]
    });
};


/***/ }),

/***/ 86555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ ArticleTagsList; },
/* harmony export */   "GJ": function() { return /* binding */ MetaTagLink; },
/* harmony export */   "H$": function() { return /* binding */ ArticleHeaderLinkH1; },
/* harmony export */   "H_": function() { return /* binding */ ArticleShareWrapper; },
/* harmony export */   "M3": function() { return /* binding */ ArticleSummaryReadMore; },
/* harmony export */   "O": function() { return /* binding */ ArticleShareIcon; },
/* harmony export */   "Q4": function() { return /* binding */ ArticleSummaryWrapper; },
/* harmony export */   "Qi": function() { return /* binding */ ArticleNextTitle; },
/* harmony export */   "RR": function() { return /* binding */ ArticleNextMeta; },
/* harmony export */   "X4": function() { return /* binding */ ArticleOrderedListItem; },
/* harmony export */   "XC": function() { return /* binding */ ArticleNextWrapper; },
/* harmony export */   "_6": function() { return /* binding */ ArticleSummaryContent; },
/* harmony export */   "bO": function() { return /* binding */ ArticlesListSection; },
/* harmony export */   "c3": function() { return /* binding */ ArticleHeaderLink; },
/* harmony export */   "cK": function() { return /* binding */ ArticleOrderedList; },
/* harmony export */   "hv": function() { return /* binding */ MetaName; },
/* harmony export */   "on": function() { return /* binding */ ArticleTagItem; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; },
/* harmony export */   "yY": function() { return /* binding */ MetaDate; },
/* harmony export */   "zt": function() { return /* binding */ ArticleParagraph; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16829);
/* harmony import */ var _styles_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8066);
/* harmony import */ var _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22004);
/* harmony import */ var emotion_rgba__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49484);
/* harmony import */ var emotion_rgba__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(emotion_rgba__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44718);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 568px;\n    padding: 0;\n    margin-bottom: 7.5rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 0.0625rem solid ",
        ";\n      box-sizing: border-box;\n      border-radius: 3.75rem;\n\n      &:hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-left: 2.5em;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: sticky;\n    top: 10rem;\n    margin-top: 19rem;\n    margin-bottom: 11rem;\n    max-height: 11.4rem;\n    max-width: 3rem;\n    flex-direction: column;\n    margin-left: 0;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-left: 0;\n      margin-top: 1rem;\n    "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    &:not(:last-child) {\n      margin-bottom: 3rem;\n    }\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin: 1rem 0 0 0;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin: 0 0 1rem 0;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 2rem;\n    line-height: 2.5rem;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin: 0 0 1rem 0;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 2rem;\n    line-height: 2.5rem;\n  "
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    gap: 1.875rem;\n  "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 1.5rem;\n    line-height: 2rem;\n  "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}







const ArticlesListSection = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("section", {
    target: "e6co0co0"
})("display:flex;flex-direction:column;align-items:center;margin-bottom:5rem;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject())), ";");
const ContentWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6co0co1"
})("width:100%");
const ArticleTagsList = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("ul", {
    target: "e6co0co2"
})(_styles_mixins__WEBPACK_IMPORTED_MODULE_2__/* .defaultContainerSize */ .sX, ";max-width:73rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:center;list-style:none;padding-top:1rem;padding-bottom:1rem;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-style:normal;font-weight:normal;font-size:1rem;line-height:2rem;");
const ArticleTagItem = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("li", {
    target: "e6co0co3"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";cursor:pointer;display:inline-block;padding:0.3125rem 1rem;white-space:nowrap;background:linear-gradient(\n    22.45deg,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.primary */ .C.colors.primary, " 3.28%,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.accent */ .C.colors.accent, " 102.02%\n  );background-clip:text;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.darker_grey;
}, ";transition:color 200ms ease-in-out;&:hover{color:", (0,emotion_rgba__WEBPACK_IMPORTED_MODULE_4__.rgba)(_common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.darker_grey */ .C.colors.darker_grey, 0), ";}", (param)=>{
    let { isActive  } = param;
    return isActive && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject1(), _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.darker_grey */ .C.colors.darker_grey, (0,emotion_rgba__WEBPACK_IMPORTED_MODULE_4__.rgba)(_common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.darker_grey */ .C.colors.darker_grey, 1));
}, ";");
const ArticleShareWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6co0co4"
})("display:flex;flex-direction:row;max-height:3rem;max-width:unset;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.medium((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject2())), ";", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject3())), ";");
const ArticleShareIcon = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
    target: "e6co0co5"
})("width:3rem;height:3rem;position:relative;border:0.0625rem solid ", (param)=>{
    let { theme  } = param;
    return theme.colors.grey;
}, ";border-radius:50%;transition:box-shadow 200ms ease-in-out;svg{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}&:hover{box-shadow:0.5rem 0.5rem 1.5rem 0 #1700594a;}&:not(:first-of-type){margin-left:1rem;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject4())), ";}");
const ArticleSummaryWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6co0co6"
})("&:not(:last-child){margin-bottom:4rem;}", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject5())), ";");
const ArticleSummaryContent = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6co0co7"
})("margin:1.5rem 0 0 0;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-weight:300;font-size:1rem;line-height:2rem;letter-spacing:0.013px;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject6())), ";");
const ArticleSummaryReadMore = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
    target: "e6co0co8"
})("position:relative;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-weight:600;font-size:1.125rem;line-height:2rem;text-decoration:none;background:linear-gradient(\n    22.45deg,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.primary */ .C.colors.primary, " 3.28%,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.accent */ .C.colors.accent, " 102.02%\n  );background-clip:text;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";transition:color 200ms ease-in-out;&:after{background:linear-gradient(\n      67.33deg,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.primary */ .C.colors.primary, " -19.99%,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.accent */ .C.colors.accent, " 98.54%\n    );transition:opacity 200ms ease-in-out;opacity:0;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__/* .pseudoElementDefaultContent */ .CR, ";}&:before{background:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__/* .pseudoElementDefaultContent */ .CR, ";}&:hover{color:", (0,emotion_rgba__WEBPACK_IMPORTED_MODULE_4__.rgba)(_common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.core_black */ .C.colors.core_black, 0), ";&:after{opacity:1;}}");
const ArticleHeaderLink = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
    target: "e6co0co9"
})(_core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__/* .Headline4 */ .Ou, ";margin:0 0 0.5rem 0;background:linear-gradient(\n    22.45deg,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.primary */ .C.colors.primary, " 3.28%,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.accent */ .C.colors.accent, " 102.02%\n  );background-clip:text;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";text-decoration:none;transition:color 200ms ease-in-out;display:block;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.medium((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject7())), ";", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.large((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject8())), ";&:hover{color:", (0,emotion_rgba__WEBPACK_IMPORTED_MODULE_4__.rgba)(_common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.black */ .C.colors.black, 0), ";}&:focus{outline:none;}");
const ArticleHeaderLinkH1 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("h1", {
    target: "e6co0co10"
})(_core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__/* .Headline4 */ .Ou, ";margin:0 0 0.5rem 0;background:linear-gradient(\n    22.45deg,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.primary */ .C.colors.primary, " 3.28%,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.accent */ .C.colors.accent, " 102.02%\n  );background-clip:text;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";text-decoration:none;transition:color 200ms ease-in-out;display:block;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.medium((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject9())), ";", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.large((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject10())), ";&:hover{color:", (0,emotion_rgba__WEBPACK_IMPORTED_MODULE_4__.rgba)(_common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.black */ .C.colors.black, 0), ";}&:focus{outline:none;}");
const MetaName = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("span", {
    target: "e6co0co11"
})(_core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__/* .ParagraphS */ .fw, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-weight:400;letter-spacing:0.0125rem;");
const MetaDate = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("span", {
    target: "e6co0co12"
})(_core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__/* .ParagraphXs */ .CJ, ";font-weight:400;");
const MetaTagLink = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
    target: "e6co0co13"
})(_core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__/* .ParagraphXs */ .CJ, ";font-weight:400;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.darker_grey;
}, ";");
const ArticleParagraph = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("p", {
    target: "e6co0co14"
})(_core_Typography_Typography__WEBPACK_IMPORTED_MODULE_6__/* .ParagraphS */ .fw, ";margin:1.5rem 0;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";");
const ArticleOrderedList = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("ol", {
    target: "e6co0co15"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin:0.75rem 0;padding-left:1.5rem;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-size:1rem;line-height:1.5rem;counter-reset:custom-counter;list-style:none outside none;position:relative;");
const ArticleOrderedListItem = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("li", {
    target: "e6co0co16"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin:0.75rem 0;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";font-size:1rem;line-height:1.5rem;counter-increment:custom-counter;&:before{content:counter(custom-counter) ') ';color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";font-weight:bold;position:absolute;left:0;}");
const ArticleNextWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6co0co17"
})("display:inline-flex;flex-wrap:nowrap;gap:1rem;", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.medium((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject11())), ";");
const ArticleNextMeta = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6co0co18"
})("display:flex;flex-direction:column;justify-content:center;max-width:23.125rem;");
const ArticleNextTitle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
    target: "e6co0co19"
})("position:relative;font-size:1.125rem;line-height:1.5rem;font-family:var(--font-base);text-decoration:none;font-weight:normal;background:linear-gradient(\n    22.45deg,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.primary */ .C.colors.primary, " 3.28%,", _common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.accent */ .C.colors.accent, " 102.02%\n  );background-clip:text;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";transition:color 200ms ease-in-out;cursor:pointer;&:hover{color:", (0,emotion_rgba__WEBPACK_IMPORTED_MODULE_4__.rgba)(_common_consts_theme__WEBPACK_IMPORTED_MODULE_3__/* .THEME.colors.dark_grey */ .C.colors.dark_grey, 0), ";}", _styles_mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject12())), ";");


/***/ })

}]);